import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18nNamespace } from 'constants/i18n.const';
import { useTranslation } from 'hooks/useTranslation';
import { QRCodeCanvas } from 'qrcode.react';
import React from 'react';

const PolicyPopupContent = () => {
  const { T } = useTranslation([I18nNamespace.COMMON]);
  return (
    <div>
      <Typography
        className="mb-16 mt-10"
        variant={TYPOGRAPHY_VARIANTS.H1}
        upperCase
      >
        {T('notification')}
      </Typography>
      <Typography
        className="my-16"
        variant={TYPOGRAPHY_VARIANTS.BODY}
        firstCapCase
      >
        {T('notificationContent')}
      </Typography>
      <Typography variant={TYPOGRAPHY_VARIANTS.BODY} firstCapCase>
        {T('scanQRtoViewPolicy')}
      </Typography>
    </div>
  );
};

export default PolicyPopupContent;
